<template>
  <div
    :class="!expandUVS ? 'md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50' : 'md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100'"
    style="z-index: 2"
  >
    <md-card>
      <md-card-header data-background-color="newyellow">
        <div style="display: flex; justify-content: space-between;align-items: center;">
          <h5 class="tittle">Usuários conectados por versão de outros aplicativos</h5>
          <font-awesome-icon
            v-show="expandUVS"
            @click="expandUVS=false"
            style="cursor: pointer;"
            icon="times-circle"
          />
        </div>
      </md-card-header>
      <md-card-content style="de">
        <div style="display: flex; justify-content: space-around;">
          <div :class="!expandUVS ? 'graphcontent' : 'graphcontent2'">
            <apexchart
              v-if="series.length != 0"
              type="pie"
              width="600"
              height="400"
              :options="chartOptions"
              :series="series"
            />
            <div v-else class="nographic">
              <div class="alerta" style="margin:0px!important;">
                <font-awesome-icon
                  icon="exclamation-circle"
                  style="margin-right: 8px;margin-left:8px;"
                />Sem dados disponíveis
              </div>
            </div>
            <v-radio-group
              style="width: 100%;    justify-content: center;
                      display: flex;"
              row
              v-model="aplicativoAtual"
              @change="changeAplicativo"
            >
              <v-radio checked label="EMS" value="0"></v-radio>
              <v-radio label="Firebird" value="1"></v-radio>
              <v-radio label="Suporte" value="2"></v-radio>
              <v-radio label="DFE" value="3"></v-radio>
              <v-radio label="Windows" value="4"></v-radio>
            </v-radio-group>
          </div>
        </div>
        <transition>
          <div v-if="expandUVS">
            <div style="display: flex;
    justify-content: flex-start;
    align-items: center;">
              <div style="border-left: 5px solid #2b5577;padding-left:10px">
                <h4>
                  <b>Clientes conectados por versão do EMS:</b>
                </h4>
                <p>Segure shift para selecionar várias versões</p>
              </div>
              <div style="margin: 40px">
                <v-chip
                  style="color: #fff"
                  color="#2b5577"
                  close
                  v-for="versao in versaoAtual"
                  :key="versao.DESCR"
                  @input="removeVersao(versao)"
                >{{versao.DESCR}}</v-chip>
              </div>
            </div>
            <Clientes @filters="filtering" v-if="clientesExibir && versaoAtual" :versoesEMS="versaoAtual" :aplicativo="aplicativoAtual" :atividades="atividades" :personas="personas" :analistas="analistas" :arquivos="arquivos" />
            <div class="alerta" v-else>
              <font-awesome-icon
                icon="exclamation-circle"
                style="margin-right: 8px;margin-left:8px;"
              />Você deve selecionar uma versão para exibição
            </div>
          </div>
        </transition>
      </md-card-content>
    </md-card>
      <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>
import * as GraficosService from "../../providers/graficos.service";
import Clientes from "../Clientes/tabelaClientes";

var jwt = require("jsonwebtoken");

export default {
  
  components: {
    Clientes
  },
  created() {
    var self = this;

    var fUser = jwt.decode(localStorage.getItem("token"));
    
    self.sistemaAtual = fUser.SEGCODIGO.includes("1") ? "9" : "2";

    self.aplicativoAtual = "0";

    self.initGraphics(self.sistemaAtual, self.aplicativoAtual, true, self.body);
    self.mestreInterval = setInterval(() => {
      self.initGraphics(self.sistemaAtual, self.aplicativoAtual, false, self.body);
    }, 20000);
  },
  beforeDestroy() {
    clearInterval(this.mestreInterval);
  },
  watch: {
    sistemaAtual: function(val) {
      self.chartOptions.labels = [];
      self.series = [];
    },
    aplicativoAtual: function(val) {
      this.refreshFilter();
    },
    atividades: function(val) {
      this.refreshFilter();
    },
    personas: function(val) {
      this.refreshFilter();
    },
    analistas: function(val) {
      this.refreshFilter();     
    },
    arquivos: function(val) {
      this.refreshFilter();     
    }
  },
  props: {
    atividades: {
      type: Array()
    },
    personas: {
      type: Array()
    },
    analistas: {
      type: Array()
    },
    arquivos: {
      type: Array()
    }    
  },
  data() {
    var self = this;
    return {
      msg: false,
      mestreInterval: false,
      originalVersaoArr: [],
      clientesExibir: false,
      body: {
        filter: false,
        versoes: false,
        versoesEMS: false,
        filterBloqueados: false,
        aplicativo: false
      },
      sistemaAtual: "9",
      aplicativoAtual: false,
      dataAtualizacao: new Date(),
      expandUVS: false,
      versaoAtual: Array(),
      series: [],
      chartOptions: {
        labels: [],
        legend: {
          position: "left",
          inverseOrder: true,
          offsetY: 20
        },
        dataLabels: {
          formatter: function (val, opts) {
              return [val.toFixed(1) + "%", self.series[opts.seriesIndex]]
          },
        },
        chart: {
          events: {
            dataPointSelection: function(event, chartContext, config) {
              self.grafSelect(event, chartContext, config);
            },
            legendClick: function(chartContext, seriesIndex, config) {
              config.dataPointIndex = seriesIndex;
              self.grafSelect(event, chartContext, config);
            }
          }
        },
        expandOnClick: false,
        colors: ["#2A5377", "#88C658", "#44736E", "#71AA60", "#53856a"],
        responsive: [
          {
            breakpoint: 1600,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: "right"
              }
            }
          },
          {
            breakpoint: 500,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: "left"
              }
            }
          }
        ],
        stroke: {
          width: 0
        }
      }
    };
  },
  methods: {
    filtering(ev){
      var self = this;
      self.msg = "Atualizando.."
      clearInterval(self.mestreInterval);
      self.mestreInterval = false;
      self.initGraphics(sistemaAtual, aplicativoAtual, false, ev);
      self.mestreInterval = setInterval(() => {
        self.initGraphics(sistemaAtual, aplicativoAtual, false, self.body);
      }, 20000);
    },
    removeVersao(versao) {
      var self = this;
      self.versaoAtual.remove(versao);
      if (self.versaoAtual.length == 0) {
        self.clientesExibir = false;
        self.expandUVS = false;
      }
    },
    changeAplicativo(){
      var self = this;

      self.initGraphics(self.sistemaAtual, self.aplicativoAtual, false, self.body);
      self.mestreInterval = setInterval(() => {
        self.initGraphics(self.sistemaAtual, self.aplicativoAtual, false, self.body);
      }, 20000);
    },
    refreshFilter(){
      var self = this;
      clearInterval(self.mestreInterval);
      self.chartOptions.labels = [];
      self.series = [];
      self.initGraphics(self.sistemaAtual, self.aplicativoAtual, true, self.body);
      self.mestreInterval = setInterval(() => {
        self.initGraphics(self.sistemaAtual, self.aplicativoAtual, false, self.body);
      }, 20000);
    },
    initGraphics(SISCODIGO, aplicativo, first, filters) {
      var self = this;
      var pArquivos = self.arquivos.map((e) => {
        return e.split(' (')[0];
      });      

      GraficosService.getDataGraficoDashVersaoEMS(Number(SISCODIGO), aplicativo, {...filters, ...{atividades: self.atividades, personas: self.personas, analistas: self.analistas, arquivos: pArquivos}}).then(r => {
        var ar1 = [];
        var ar2 = [];
        var arrayAux = [];

        if (!r){
          self.originalVersaoArr = Object.assign([], r);
          return;
        }

        if ((aplicativo == 0) || (aplicativo == 3)){
          arrayAux = r.sort((a, b) => {
            var asp = a.DESCR.split('.');
            var bsp = b.DESCR.split('.');

            for (var i = 0; i <4; i++)
              if (asp.length <= i)
                return -1
              else if (bsp.length <= i)
                return 1
              else if (parseInt(asp[i]) != parseInt(bsp[i]))
                return parseInt(asp[i]) - parseInt(bsp[i])
          })
          
          self.originalVersaoArr = Object.assign([], arrayAux);
        } else
          self.originalVersaoArr = Object.assign([], r);

        r.forEach(element => {
          ar1.push(element.DESCR);
          ar2.push(element.COUNT);
        });
       

        if (!first && self.chartOptions.labels.length != ar1.length && self.series.length != ar2.length) {
          self.chartOptions.labels = [];
          self.series = [];
          setTimeout(() => {
            self.chartOptions.labels = ar1;
            self.series = ar2;
          }, 1);
        } else {
          if (self.chartOptions.labels.length == ar1.length && self.series.length == ar2.length) {

          } else {
            self.chartOptions.labels = ar1;
            self.series = ar2;
          }
        }
      });
    },
    grafSelect(event, chartContext, config) {
      var self = this;

      var index = Number(config.dataPointIndex);
      self.clientesExibir = true;
      if (event) {
        if (event.shiftKey) {
          var exist = false;
          self.versaoAtual.forEach(el => {
            if (el == self.originalVersaoArr[index]) exist = true;
          });
          if (!exist) self.versaoAtual.push(self.originalVersaoArr[index]);
        } else {
          self.versaoAtual = Array();
          self.versaoAtual.push(self.originalVersaoArr[index]);
        }
        self.expandUVS = true;
      }
    }
  }
};
</script>
<style scoped>
.md-tabs-navigation {
  padding-left: 200px !important;
}
.md-card .md-tabs.md-success .md-tabs-navigation {
  padding-left: 139px !important;
}
.graphcontent {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}
.graphcontent2 {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.md-layout-item {
  transition: all 0.3s ease-in-out !important;
}
div {
  transition: all 0.3s ease-in-out !important;
}
.vue-map-container {
  height: 82vh !important;
}
.alerta {
  margin: 46px;
  border: 1px solid #f90;
  padding: 10px;
  border-radius: 6px;
  color: #f90;
}
.nographic {
  width: 500px;
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
}
</style>

